module.exports = __webpack_public_path__ + "img/94.05133944.jpg";